// @flow
import FlagSpinner from './FlagSpinner';

export default FlagSpinner;
